var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-empty-state"},[(_vm.icon)?_c('PxIcon',{attrs:{"name":("empty-state/" + _vm.icon),"size":"93"}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }